import React, { FC } from 'react';

import { Switch, Route, Router, Redirect } from 'react-router-dom';

import PrioridadeSolicitacaoPage from 'view/page/PrioridadeSolicitacao/PrioridadeSolicitacaoPage';
import UsuarioPermissaoPage from 'view/page/UsuarioPermissaoPage/UsuarioPermissaoPage';
import NotificacoesPage from 'view/page/NotificacoesPage/NotificacoesPage';
import { InicialPage } from 'view/page/InicialPage/InicialPage';
import SobrePage from 'view/page/SobrePage/SobrePage';
import { SLAPage } from 'view/page/SLAPage/SLAPage';
import { BuscaPage } from 'view/page/BuscaPage/BuscaPage';
import { Page } from 'view/page/Page/Page';
import { Sentry } from 'service/Sentry';
import { SolicitacaoAnexoPage } from 'view/page/SolicitacaoAnexoPage/SolicitacaoAnexoPage';
import { SolicitacaoServicoPage } from 'view/page/SolicitacaoServicoPage/SolicitacaoServicoPage';
import { TesteFormularioPage } from 'view/page/TesteFormularioPage/TesteFormularioPage';
import { MinhasSolicitacoesPage } from 'view/page/SolicitacoesPage/MinhasSolicitacoesPage';
import { SolicitacoesDoReinoPage } from 'view/page/SolicitacoesPage/SolicitacoesDoReinoPage';
import ClassificacaoPage from 'view/page/ClassificacaoPage/ClassificacaoPage';


export const Routes: FC = () => {
  return (
    <Router history={Sentry.instance.history}>
      <Switch>
        <Page exact path="/" component={InicialPage} title="Página inicial">
          <Redirect to="/solicitacoes/" />
        </Page>

        <Page path="/solicitacoes/new" component={SolicitacaoServicoPage} title="Nova solicitação" />
        
        <Route path="/solicitacoes/:id(\d+)"
          render={(props) => {
            const id = (props.match.params as any)['id'];
            const titulo = id
              ? `Solicitação #${id}`
              : 'Solicitação #0 (fluxo não mapeado)';

            return <Page title={titulo}>
              {/* <SolicitacaoServicoPage {...props} /> */}
              <SolicitacaoServicoPage {...props} />
            </Page>
          }}
        />
        <Page
          exact path="/reinos/:idReino(\d+)/solicitacoes/:idSolicitacao(\d+)/anexos/:idAnexo"
          title="Acesso a arquivo"
          component={SolicitacaoAnexoPage}
        />

        <Page exact path="/solicitacoes/" component={MinhasSolicitacoesPage} title="Minhas solicitações" />
        <Page exact path="/solicitacoes/reino" component={SolicitacoesDoReinoPage} title="Solicitações do reino" />

        <Page exact path="/prioridades" component={PrioridadeSolicitacaoPage} title="Prioridades" />
        <Page exact path="/notificacoes" component={NotificacoesPage} title="Notificações" />

        <Page exact path="/admin/permissoes" component={UsuarioPermissaoPage} title="Papéis e Permissões" />
        <Page exact path="/admin/classificacoes" component={ClassificacaoPage} title="Classificações" />

        <Page exact path="/sla" component={SLAPage} title="Painel SLA" />
        <Page exact path="/sobre" component={SobrePage} title="Sobre" />

        <Page path="/busca" component={BuscaPage} title="Busca de solicitações" />
        <Page path="/testeFormulario" component={TesteFormularioPage} title="Teste de formulário" />

        {/* <Route path="/silent-check-sso" component={SilentCheckSSOPage}></Route> */}

        <Route path="*" component={Page}></Route>
      </Switch>
    </Router>
  );
}
